import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Form, Image } from 'react-bootstrap';
import { getMemberToVerify } from '../../utils/redshif-data-api.js';
import { processUserEmailVerification, resendVerificationEmail, getUserByEmail } from '../../utils/cognito-api.js';
import { ERROR_MESSAGES, RECOVER_DONE, RECOVER_FAILED } from '../../data/ForgotPinConstants.js';
import { Header } from '../header/header.js';
import { useTranslation } from 'react-i18next';
import { rememberPin } from '../rememberPin/rememberPin.js';
import { Auth } from 'aws-amplify';


function ForgotPin(props) {
    const [IDbetis, setIDbetis] = useState('');
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState('');
    const [touched, setTouched] = useState({});
    const navigate = useNavigate();
    const [lenguage, setLanguage] = useState('es');
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const {state} = useLocation();
    const authType = state;
    const token = queryParams.get('token');
    const [isLoading, setIsLoading] = useState(false);

    const onChangeLanguage = (newLanguage) => {
        setLanguage(newLanguage);
        i18n.changeLanguage(newLanguage);
    };

    const handleResendConfirmationCode = (token) => {
        if (authType === 'user_pass'){
        navigate(`/confirmcode?email=${encodeURIComponent(email)}&token=${token}&status=sended&forgotpass=true`);
        }else {
       navigate(`/confirmcode?email=${encodeURIComponent(email)}&id=${IDbetis}&token=${token}&status=sended`);
        }
    };

    const handleRecoverPassword = async function (email) {

        const user = await getUserByEmail(email);
        const username = user.Username;
        Auth.forgotPassword(username)
            .then(() => {
                navigate(`/changepassword?token=${token}&username=${encodeURIComponent(username)}`);
            });
    };


    const handleBlur = (field, value) => {
        if(value){
            setTouched((prevTouched) => ({...prevTouched, [field]: true }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};

        if (authType === 'user_pin'){
            if (!IDbetis.trim()) {
                newErrors.IDbetis = ERROR_MESSAGES.emptyField;
            } else if (!/^[0-9]+$/i.test(IDbetis)) {
                newErrors.IDbetis = ERROR_MESSAGES.idbetisFormat;
                console.log(errors)
            } else {
                delete newErrors.IDbetis;
                setErrors(newErrors);
            }
        }

        if (!email.trim()) {
            newErrors.email = ERROR_MESSAGES.emptyField;
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
            newErrors.email = ERROR_MESSAGES.emailFormat;
            console.log(errors)
        } else {
            console.log(errors)
            delete newErrors.email;
            setErrors(newErrors);
        }

        if (Object.keys(newErrors).length > 0) {
            console.log(Object.keys(newErrors).length)
            setErrors(newErrors);
        } else {
            if (authType === 'user_pin'){
                setIsLoading(true);
                const valid = await getMemberToVerify(IDbetis, email);
                if(valid.length === 1){
                    const verified = await processUserEmailVerification(email);
                    if(verified){
                        setIsLoading(false);
                        setMessage(RECOVER_DONE);
                        await rememberPin(email, IDbetis);
                        navigate(`/?token=${token}&status=sended`);
                    }else{
                        setIsLoading(false);
                        handleResendConfirmationCode(token);
                    }
                } else {
                    setIsLoading(false);
                    setMessage(RECOVER_FAILED);
                }
            }
            if (authType === 'user_pass'){
                setIsLoading(true);
                const verified = await processUserEmailVerification(email);
                    if(verified){
                        setIsLoading(false);
                        handleRecoverPassword(email);
                    }else{
                        setIsLoading(false);
                        handleResendConfirmationCode(token);
                    }
            }
        }
    }


    return (
        <Container fluid>
            <Header setLanguage={onChangeLanguage} />
            <Row className="px-4 my-5 formLogin">
                <Col sm={4} className="resize">
                    {isLoading && <div class="loader"></div>}
                    <Form onSubmit={handleSubmit}>
                    {message && <div className="errorPin">{message}</div>}
                        {authType === 'user_pin' && <Form.Group className="mb-3 mt-5 position-relative" controlId="formBasicText">
                            <Form.Label className="fit">{t('inputIDbetis')}</Form.Label>
                            <Form.Control name="IDbetis" type="text" className="aditionalInfo" placeholder={t('placeholderId')} value={IDbetis} onBlur={(e) => handleBlur('IDbetis', e.target.value)} 
                                onChange={(e) => setIDbetis(e.target.value)} isInvalid={errors.IDbetis} />
                            <Form.Control.Feedback className="error" type="invalid" tooltip>{t(`${errors.IDbetis}`)}</Form.Control.Feedback>
                        </Form.Group>}
                        <Form.Group className="mb-5 mt-5 position-relative" controlId="formBasicText">
                            <Form.Label className="fit">{t('inputEmail')}</Form.Label>
                            <Form.Control 
                                name="email" 
                                type="text" 
                                className="aditionalInfo" 
                                placeholder={t('placeholderEmail')} 
                                value={email}  
                                onBlur={(e) => handleBlur('email', e.target.value)} 
                                onChange={(e) => setEmail(e.target.value.toLowerCase())} 
                                isInvalid={errors.email} 
                            />
                            <Form.Control.Feedback className="error" type="invalid" tooltip>{t(`${errors.email}`)}</Form.Control.Feedback>
                        </Form.Group>
                        <button className="btnLogin" type="submit" onClick={handleSubmit}>{t('recover')}</button>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
}

export default ForgotPin;